const moment = require('moment');
const defaultMargin = 30;

import MaterialService from "@/views/offer/material.service.js";
import MontageService from "@/views/offer/montage.service";

const CertainCustomer = {
    Gascade : "GASCADE Gastransport GmbH"
}

var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PdfService = () => {

    let getDefaultStyle = () => {
        return {
            tableExample: {
                fontSize: 8,
            },
            header: {
                margin: [0, 10, 0, 10],
                fontSize: 10,
                alignment: 'center',
                bold: true
            },
            tableHeader: {
                fillColor: '#3eb286',
                bold: true
            },
            checklistInfos: {
                fontSize: 10,
                bold: false,
                alignment: 'left',
                margin: [0, 2, 0, 2]
            },
            superMargin: {
                margin: [0, 10, 0, 20]
            },
            m20top: {
                margin: [0, 20,0,0]
            },
            m20bottom: {
                margin: [0, 0, 0, 20]
            }
        };
    };

    const getDefaultHeader = () => {
        return [
            {
                image: "data:image/png;base64,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",
                fit: [200, 100],
                margin: [defaultMargin, defaultMargin, 0, 5]
            }, {

            }, {
                margin: [0, 2, 0, 0],
                canvas: [
                    {
                        type: 'rect',
                        x: defaultMargin,
                        y: 0,
                        w: 565 - defaultMargin,
                        h: 1,
                        color: '#3eb286'
                    }
                ]
            }
        ];
    };

    const getDefaultFooter = (defaultMargin ) => {
        return [
            {
                margin: [0, 2, 0, 2],
                canvas: [
                    {
                        type: 'rect',
                        x: defaultMargin,
                        y: 0,
                        w: 565 - defaultMargin,
                        h: 1,
                        color: '#3eb286'
                    }
                ]
            },
            {
                margin: [defaultMargin, 0],
                fontSize: 8,
                alignment: 'justify',
                columns: [
                    {
                        stack: [
                            'Fahlke Control Systems KG',
                            'Rudolf-Diesel-Str. 3',
                            'D-27356 Rotenburg (Wümme)'
                        ]
                    },
                    {
                        stack: [
                            'Phone: + 49 (0) 42 61 9143-0',
                            'Fax: + 49 (0) 42 61 9143-143',
                            'E-Mail: csg@fahlke.de'
                        ]
                    },
                    {
                        columns: [
                            {
                                width: 15,
                                text: ''
                            },
                            {
                                alignment: 'left',
                                stack: [
                                    'Amtsgericht Walsrode HRA62027',
                                    'Gerichtsstand Rotenburg',
                                    'Ust-Id-Nr.: DE 116324270'
                                ]
                            }
                        ]
                    },
                    {
                        stack: ['Markus Fahlke (GF)'],
                        width: 90,
                        style: {
                            alignment: 'right'
                        }
                    }
                ]
            }
        ];
    };

    const generateOffer = async (station, customer, offer, address, selectedUser) => {

        const machines = offer.material.offerMachines;
        let offerContent = [];
        const generateContent = () => {

            offerContent.push(
                {
                    columns: [
                        {width: 300, text: 'to:', style: 'italics: true'},
                        {width: 300, text: 'from:', style: 'italics: true'}
                    ]
                },
                {
                    columns: [
                        {width: 300, text: `${address.customerName}`, style: 'checklistInfos'},
                        {width: 300, text: 'Fahlke Control Systems KG', style: 'checklistInfos'}
                    ]
                },
                {
                    columns: [
                        {width: 300, text: `${address.contactPerson}`, style: 'checklistInfos'},
                        {width: 300, text: `${selectedUser.nameShort} (${selectedUser.title})`, style: 'checklistInfos'}
                    ]
                },
                {
                    columns: [
                        {width: 300, text: ``, style: 'checklistInfos'},
                        {width: 300, text: `Datum: ${moment().format("DD.MM.YYYY")}`, style: 'checklistInfos'}
                    ]
                },
                {
                    columns: [
                        {width: 300, text: `${address.street}`, style: 'checklistInfos'},
                        {width: 300, text: ``, style: 'checklistInfos'}
                    ]
                },

                {
                    columns: [
                        {width: 300, text: `${address.zipCode} ${address.city}`, style: 'checklistInfos'},
                        {width: 300, text: `Tel.:  ${selectedUser.tel}`, style: 'checklistInfos'}

                    ]
                },
                {
                    columns: [
                        {width: 300, text: `${address.country}`, style: 'checklistInfos'},
                        {width: 300, text: `Fax:  ${selectedUser.fax}`, style: 'checklistInfos'}

                    ]
                },
                {
                    columns: [
                        {width: 300, text: ``, style: 'checklistInfos'},
                        {width: 300, text: `E-Mail:  ${selectedUser.email}`, style: 'checklistInfos'}
                    ]
                },

                {
                    columns: [
                        {width: 300, text: `Tel: ${customer.phone}`, style: 'checklistInfos'},
                        {width: 300, text: `Kopie: ${selectedUser.cc}`, style: 'checklistInfos'},
                    ]
                },
                {
                    columns: [
                        {width: 300, text: `E-Mail: ${address.mail}`, style: 'checklistInfos'},
                        {width: 300, text: ``, style: 'checklistInfos'},
                    ]
                },

                ['\n'],
                ['\n'],


            );

            offerContent.push([
                {
                    columns: [
                        {width: 100, text: 'Angebots-Nr.:', bold: true, fontSize: 10},

                        {width: 450, text: `${offer.angebotsNr}`,  fontSize: 10}
                    ]
                },
                {
                    columns: [
                        {width: 100, text: 'Ihre Anfrage:', bold: true, fontSize: 10},
                        {width: 450, text: `${offer.ihreAnfrage}`, fontSize: 10,}
                    ],
                    style: 'superMargin'
                },
                {
                    text: `Sehr geehrte/r ${offer.contactPerson},`, fontSize: 10
                },
                '\n',
                {
                    text: `${offer.anrede}`, fontSize: 10
                },
                '\n',
            ]);



            const buildTableBodyOffer = (columnNames) => {
                var body = [];

                const headerColumns = columnNames.map((column) => {
                    let myColSpan = 1;
                    return {
                        text: column,
                        style: 'tableHeader',
                        colSpan: myColSpan
                    };
                });

                body.push(headerColumns);

                return body;
            };

            const generateTableOffer = (type, columnNames) => {
                let tableBodyCellWidths;
                if(type === 'material') {
                    tableBodyCellWidths = [20, 80, 110, 70, 20, 70, 70]; // 440
                } else if(type === 'montage') {
                    tableBodyCellWidths = [20, 110, 50, 140, 140]; // 460
                } else {
                    tableBodyCellWidths = [20, 90, 50, 150, 150];
                }
                return {
                    style: 'tableExample',
                    table: {
                        body: buildTableBodyOffer(columnNames),
                        widths: tableBodyCellWidths,
                    }
                };
            };

            offerContent.push([
                {text: 'Kommerzielle Bedingung:', decoration: 'underline', fontSize: 10},
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Angebotswert Material:', fontSize: 10},

                        {width: 350, text: `${currencyParser(offer.material.angebotswertMaterial)} netto zzgl. MwSt.`,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Angebotswert Montage:', fontSize: 10},

                        {width: 350, text: `${currencyParser(offer.montage.sumMontage)} netto zzgl. MwSt.`,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Lieferzeit Material:', fontSize: 10},

                        {width: 350, text: offer.lieferzeitMaterial === null ? '-' : offer.lieferzeitMaterial,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Lieferzeit Montage:', fontSize: 10},

                        {width: 350, text: offer.lieferzeitMontage === null ? '-' : offer.lieferzeitMontage,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Lieferbedingung:', fontSize: 10},

                        {width: 350, text: offer.lieferbedingungen === null ? '-' : offer.lieferbedingungen,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Zahlungsbedingung:', fontSize: 10},

                        {width: 350, text: offer.zahlungsbedingungen === null ? '-' : offer.zahlungsbedingungen,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Gewährleistungen:', fontSize: 10},

                        {width: 350, text: offer.gewaehrleistungen === null ? '-' : offer.gewaehrleistungen,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Technische Lieferbedingung:', fontSize: 10},

                        {width: 350, text: offer.technischeLieferbedingungen === null ? '-' : offer.technischeLieferbedingungen,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Dokumentation:', fontSize: 10},

                        {width: 350, text: offer.dokumentationen === null ? '-' : offer.dokumentationen,  fontSize: 10}
                    ]
                },
                '\n',
                {
                    columns: [
                        {width: 150, text: 'Angebotsgültigkeit:', fontSize: 10},

                        {width: 350, text: offer.angebotsgueltigkeit === null ? '-' : offer.angebotsgueltigkeit,  fontSize: 10}
                    ]
                },
                '\n',
                '\n',








                /*{text: `Angebotswert Material: ${currencyParser(offer.material.angebotswertMaterial)}`, /!*margin: [20, 0],*!/  fontSize: 10},
                '\n',
                {text: `Angebotswert Montage: ${currencyParser(offer.montage.sumMontage)}`, fontSize: 10},
                '\n',*/

                /*{text: `Lieferzeit Material: ${offer.lieferzeitMaterial === null ? '-' : offer.lieferzeitMaterial} `,  fontSize: 10},
                '\n',*/
                /*{text: `Lieferzeit Montage: ${offer.lieferzeitMontage === null ? '-' : offer.lieferzeitMontage}`,  fontSize: 10},
                '\n',*/
                /*{text: `Lieferbedingung: ${offer.lieferbedingungen === null ? '-' : offer.lieferbedingungen}`,  fontSize: 10},
                '\n',*/
                /*{text: `Zahlungsbedingung: ${offer.zahlungsbedingungen === null ? '-' : offer.zahlungsbedingungen}`,  fontSize: 10},
                '\n',*/
                /*{text: `Gewährleistungen: ${offer.gewaehrleistungen === null ? '-' : offer.gewaehrleistungen}`,  fontSize: 10},
                '\n',*/
                /*{text: `Technische Lieferbedingung: ${offer.technischeLieferbedingungen === null ? '-' : offer.technischeLieferbedingungen}`,  fontSize: 10},
                '\n',*/
                /*{text: `Dokumentation: ${offer.dokumentationen === null ? '-' : offer.dokumentationen}`,  fontSize: 10},
                '\n',*/
                /*{text: `Angebotsgültigkeit: ${offer.angebotsgueltigkeit === null ? '-' : offer.angebotsgueltigkeit}`,  fontSize: 10},
                '\n',
                '\n',*/
                {text: 'Mit freundlichen Grüßen',  fontSize: 10},
                {text: 'Fahlke Control Systems',   fontSize: 10},
                '\n',
                {text: `${selectedUser.name}`, pageBreak: 'after',  fontSize: 10},

            ]);

            let tableContentMaterialOffer;
            let tableContentMontageOffer;
            let tableContentDokumentationOffer;

            tableContentMaterialOffer = generateTableOffer('material', ['Pos.', 'Benennung', 'Artikel Bezeichnung (Kurztext Lexware) ', 'Art.Nr.', 'Stk.', 'Preis/Stk.', 'Preis/Pos.']);
            tableContentMontageOffer = generateTableOffer('montage', ['Pos.', 'Benennung', 'Stk.', 'Preis/Stk.', 'Preis/Pos.']);
            tableContentDokumentationOffer = generateTableOffer('dokumentation', ['Pos.', 'Benennung', '.', 'Std.', 'Preis']);

            let sum = 0;
            for (const [index, value] of machines.entries()) {
                sum += value.preisPos;
                tableContentMaterialOffer.table.body.push([
                    {text: `${1}.${1 + index} `, colSpan: 1, alignment: 'center'},
                    {text: `${value.actuator}`, colSpan: 1, alignment: 'left'},
                    {text: value.kurztext, colSpan: 1, alignment: 'left'},
                    {text: value.artikelNr, colSpan: 1,},
                    {text: value.stk, colSpan: 1, alignment: 'center'},
                    {text: currencyParser(value.preisStk), colSpan: 1, alignment: 'right'},
                    {text: currencyParser(value.preisPos), colSpan: 1, alignment: 'right'},
                ]);

            }

            tableContentMaterialOffer.table.body.push([
                {text: currencyParser(sum), colSpan: 7, alignment: 'right', bold: true}
            ]);

            offerContent.push(
                {text: `1. Material`, fontSize: 12, bold: true},
                {text: `\n`},
            );

            offerContent.push(tableContentMaterialOffer);
            offerContent.push(
                {text: `\n`},
                {text: `Bemerkungen`, bold: true},
                {text: `${offer.bemerkungMaterial}`, fontSize: 10, italics: true},
                {text: `\n`},
                {text: `\n`},
            );
            offerContent.push(
                {text: `2. Montageaufwand`, fontSize: 12, bold: true},
                {text: `\n`},
            );

            let montageService = MontageService(CertainCustomer.Gascade === customer.name);
            let montageBenennung = ['Halbtagespauschale', 'Tagespauschale', 'Überstunden', 'Übernachtung', 'Reisekostenpauschale']
            let montageStueck = ['halbtagspauschale', 'tagespauschale', 'ueberstunden', 'uebernachtung', 'reisekostenpauschale']
            let montageStueckpreise = [montageService.getHalbtagesPauschale(offer.montage), montageService.getTagesPauschale(offer.montage), montageService.UEBERSTUNDE, montageService.UEBERNACHTUNGSPAUSCHALE, montageService.getEntfernung(offer.montage) ]
            let montagePospreise = [montageService.halbtagesPauschale_summe(offer.montage), montageService.tagesPauschale_summe(offer.montage), montageService.ueberstunden_summe(offer.montage), montageService.uebernachtung_summe(offer.montage), montageService.getEntfernung_summe(offer.montage)]
            for(let index = 0; index < montageBenennung.length; index++) {
                tableContentMontageOffer.table.body.push([
                    {text: `${2}.${1 + index} `, colSpan: 1, alignment: 'center'},
                    {text: montageBenennung[index], colSpan: 1, alignment: 'left'},
                    {text: offer.montage[montageStueck[index]], colSpan: 1, alignment: 'center'},
                    {text: currencyParser(montageStueckpreise[index]), colSpan: 1, alignment: 'right'},
                    {text: currencyParser(montagePospreise[index]), colSpan: 1, alignment: 'right'}
                ]);
            }

            tableContentMontageOffer.table.body.push([
                {text: currencyParser(montageService.getSum(offer.montage)), colSpan: 5, alignment: 'right', bold: true}
            ]);

            offerContent.push(tableContentMontageOffer);

            offerContent.push(
                {text: `\n`},
                {text: `Bemerkungen`, bold: true},
                {text: `${offer.bemerkungMontage}`, fontSize: 10, italics: true},
                {text: `\n`},
                {text: `\n`},
            );

            tableContentDokumentationOffer.table.body.push([
                {text: `${3}.${1} `, colSpan: 1, alignment: 'center'},
                {text: `leer`, colSpan: 1, alignment: 'center'},
                {text: 'leer', colSpan: 1, alignment: 'center'},
                {text: `leer`, colSpan: 1, alignment: 'right'},
                {text: `leer`, colSpan: 1, alignment: 'right'},
            ]);

            offerContent.push(
                {text: `3. Dokumentation`, fontSize: 12, bold: true},
                {text: `\n`},
            );

            offerContent.push(tableContentDokumentationOffer);

            offerContent.push(
                {text: `\n`},
                {text: `Bemerkungen`, fontSize: 10, bold: true},
                {text: `${offer.bemerkungDokumentation}`, fontSize: 10, italics: true},
            );


            return offerContent;
        };

        const marginX = 30;
        const marginY = 90;

        const docDefinition = {
            pageMargins: [marginX, marginY, marginX, 50],
            pageSize: 'A4',
            pageOrientation: 'portrait',
            content:
                generateContent(station),
            styles: getDefaultStyle() ,
            header: function (currentPage, pageCount, pageSize) {
                return getDefaultHeader(pageSize);
            },
            footer: function () {
                return getDefaultFooter(defaultMargin);
            }

        }

        function currencyParser (value) {
            return value.toLocaleString('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2
                });
        }

        function getWartungspreis(item) {
            return MaterialService().getWartungspreis(item) * item.stk;
        }

        // TODO:
        function getArticleNo(machine) {
            if(machine.inspectionYears === 10) {
                return MaterialService().articles10[machine.actuator].new.article + '';
            } else if(machine.inspectionYears === 5) {
                return MaterialService().articles5[machine.actuator].new.article + '';
            } else {
                return MaterialService().articles1[machine.actuator].new.article + '';
            }
        }

        // TODO:
        function getArticleText(machine) {
            if (machine.inspectionYears === 10) {
                return MaterialService().articles10[machine.actuator].new.text;
            } else if (machine.inspectionYears === 5) {
                return MaterialService().articles5[machine.actuator].new.text;
            } else {
                return MaterialService().articles1[machine.actuator].new.text;
            }
        }


        pdfMake.createPdf(docDefinition).download(`Angebot-${offer.angebotsNr}.pdf`);

    };



    return {
        getDefaultStyle,
        getDefaultFooter,
        generateOffer,
        getDefaultHeader
    };
};

export default PdfService
